import { array, boolean, coerce, create, Describe, nullable, number, string, type, union } from 'superstruct';

import { DownloadFormat, DownloadFormats } from '~modules/media-library/model/DownloadFormat';
import { DownloadVariation, DownloadVariations } from '~modules/media-library/model/DownloadVariation';

export type DownloadFormatDto = {
  key: string;
  label: string;
  description: string | null;
  downloadAllowed: boolean;
  downloadUrl: string | null;
  filename: string | null;
  mimeType: string | null;
};
export type DownloadFormatListDto = Array<DownloadFormatDto>;

export const DownloadFormatDtoValidator: Describe<DownloadFormatDto> = type({
  key: string(),
  label: string(),
  description: coerce(string(), nullable(string()), val => `${val}`),
  downloadAllowed: boolean(),
  downloadUrl: nullable(string()),
  filename: nullable(string()),
  mimeType: nullable(string()),
});
export const DownloadFormatListDtoValidator: Describe<DownloadFormatListDto> = array(DownloadFormatDtoValidator);

export function makeDownloadFormat(rawDownloadFormat: DownloadFormatDto): DownloadFormat {
  return rawDownloadFormat as DownloadFormat;
}

export function makeDownloadFormats(raw: unknown) {
  const downloadFormats: DownloadFormats = {};
  try {
    const list = create(raw, DownloadFormatListDtoValidator);
    list.forEach(rawDownloadFormat => {
      const downloadFormat = makeDownloadFormat(rawDownloadFormat);
      downloadFormats[downloadFormat.key] = downloadFormat;
    });
    return downloadFormats;
  } catch (err) {
    console.error(err);
    return downloadFormats;
  }
}

export type DownloadVariationDto = {
  id: string;
  title: string;
  shortDescription: string | null;
  fileName: string;
  extension: string;
  fileSize: string | number;
  downloadUrl: string;
};
export type DownloadVariationListDto = Array<DownloadVariationDto>;

export const DownloadVariationDtoValidator: Describe<DownloadVariationDto> = type({
  id: coerce(string(), number(), val => `${val}`),
  title: string(),
  shortDescription: coerce(string(), nullable(string()), val => `${val}`),
  fileName: string(),
  extension: string(),
  fileSize: union([number(), string()]),
  downloadUrl: string(),
});
export const DownloadVariationListDtoValidator: Describe<DownloadVariationListDto> =
  array(DownloadVariationDtoValidator);

export function makeDownloadVariation(rawDownloadVariation: DownloadVariationDto): DownloadVariation {
  return rawDownloadVariation as DownloadVariation;
}

export function makeDownloadVariations(raw: unknown) {
  const downloadVariations: DownloadVariations = {};
  try {
    const list = create(raw, DownloadVariationListDtoValidator);
    list.forEach(rawDownloadVariation => {
      const downloadVariation = makeDownloadVariation(rawDownloadVariation);
      downloadVariations[downloadVariation.id] = downloadVariation;
    });
    return downloadVariations;
  } catch (err) {
    console.error(err);
    return downloadVariations;
  }
}
